import { coreColors } from '../../../../../styles/shared/variables';

export const mobileHeaderDropdownStyle = {
    width: '100%',
    textAlign: 'center'
}

export const mobileHeaderDropdownMenuItemStyle = {
    fontSize: '20px',
    color: coreColors.blue300
}


// WEBPACK FOOTER //
// ./src/components/common/dropdowns/header/styles/mobile.js